import styled from '@emotion/styled';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { LogoGameCare } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGameCare';
import { LogoGambleAware } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGambleAware';
import { LogoGamstop } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGamstop';
import { Logo18Plus } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/Logo18Plus';
import { withConfig } from 'src/withConfig';
import { LogoGamblingCommission } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGamblingComission';
import { LogoIbas } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoIbas';
import { LazyImage } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage';

interface LogoRowPropsType {
    isCentered?: boolean;
    isWrap?: boolean;
}

export const LogoRow = withConfig(theme => styled('div', { label: 'LogoRow' })<LogoRowPropsType>`
    display: flex;
    margin: 16px 0;
    align-items: ${({ isCentered }): string => isCentered === true ? 'center' : 'flex-end'};
    flex-flow: ${({ isWrap }): string => isWrap === true ? 'row wrap' : 'row nowrap'};

    @media ${theme.star.mediaQuery.mobile} {
        flex-flow: row nowrap;
    }
`);

export const SingleItem = styled('div', { label: 'SingleItem' })`
    display: flex;
    margin-right: 15px;
    &:last-of-type {
        margin-right: 0;
    }
`;

export const SingleItemLink = withConfig(theme => styled(Link, { label: 'SingleItemLink' })`
    color: ${theme.star.footerMain.txtColor};
    font-size: ${theme.star.fontSize.small};
    text-decoration: none;
`);

export const ResponsibleInfo = withConfig(theme => styled('p', { label: 'ResponsibleInfo' })`
    color: ${theme.star.footerMain.txtColor};
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.4;
    margin: 16px 0;
`);

export const LinkWrapper = withConfig(theme => styled(Link, { label: 'LinkWrapper' })`
    color: ${theme.star.footerMain.txtColorSecondary};
    display: inline-block;
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
    text-decoration: none;
    transition: color 0.2s ease;
    margin-top: 2px;
    &:hover {
        color: ${theme.star.footerMain.txtColorQuinary};
    }
`);

export const LogoGamstopWrapper = styled(LogoGamstop, { label: 'LogoGamstopWrapper' })`
    display: block;
    max-width: 83px;
    width: 100%;
`;

export const LogoGamblingCommissionWrapper = withConfig(theme => styled(LogoGamblingCommission, { label: 'LogoGamblingCommissionWrapper' })`
    display: block;
    max-width: 119px;
    width: 100%;
    margin-top: 16px;

    @media ${theme.star.mediaQuery.mobile} {
        margin-top: 0;
    }
`);

export const LogoProblemGamblingWrapper = withConfig(theme => styled(LazyImage, { label: 'LogoProblemGamblingWrapper' })`
    max-width: 56px;
    @media ${theme.star.mediaQuery.tablet} {
        max-width: 75px;
    }
`);

export const Logo18PlusWrapper = withConfig(theme => styled(Logo18Plus, { label: 'Logo18PlusWrapper' })`
    display: block;
    width: 24px;
    @media ${theme.star.mediaQuery.xxMobile} {
        width: 32px;
    }
`);

export const LogoGameCareWrapper = styled(LogoGameCare, { label: 'LogoGameCareWrapper' })`
    display: block;
    max-width: 37px;
    min-width: 30px;
    width: 100%;
`;

export const LogoGambleAwareWrapper = styled(LogoGambleAware, { label: 'LogoGambleAwareWrapper' })`
    display: block;
    max-width: 165px;
    width: 100%;
`;

export const Plus18Wrapper = styled('div', { label: 'Plus18Wrapper' })`
    display: flex;
    align-items: center;
`;

export const Plus18Text = withConfig(theme => styled('div', { label: 'Plus18Text' })`
    font-size: ${theme.star.fontSize.small};
    width: 130px;
    line-height: 1.33;
    color: ${theme.star.footerMain.txtColorSecondary};
`);

export const LogoIbasWrapper = styled(LogoIbas, { label: 'LogoIbasWrapper' })`
    max-width: 80px;
    min-width: 60px;
    vertical-align: bottom;
    width: 100%;
`;

export const LogoEcograWrapper = styled(LazyImage, { label: 'LogoEcograWrapper' })`
    max-width: 65px;
    min-width: 60px;
    vertical-align: bottom;
    width: 100%;
`;
